import { Component, Inject, Input, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { UsersService } from 'src/app/services/users.service';
import { takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TransferLeadService } from 'src/app/services/transfer-lead.service';
import { conditionalValidator } from '../utils/calsoft-validators';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';

@Component({
  selector: 'calsoft-transfer-lead',
  templateUrl: './transfer-lead.component.html',
  styleUrls: ['./transfer-lead.component.scss']
})
export class TransferLeadComponent implements OnInit, OnDestroy, AfterViewInit {

  sanitizedUrl: string = '';


  url = '';



  firstFormGroup: UntypedFormGroup;

  id: any;
  text: string;
  data: any;
  @Input() type: any;
  activityId: number;


  activityType: any;
  ownerId: any;

  typeData: any = 1;
  ownerIds: any = [];
  randomAssign: any = 0;
  enableReason: boolean = false;
  urlNew: string;

  isProcessing: boolean = false;
  totalLeads: number = 0;
  completedLeads: number = 0;
  progressPercent: number = 0;
  progressText: string = '';
  errorMessage: string = '';

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialogRef: MatDialogRef<TransferLeadComponent>,
    private leadActivityService: LeadActivityService,
    private usersService: UsersService,
    private transferLeadService: TransferLeadService,
    private route: ActivatedRoute,
    private ecryptService: EcryptServiceService,
    private cdr: ChangeDetectorRef,
  ) {

    this.data = data;

    this.urlNew = "leadTransfer";
    this.typeData = data['typeData'];
    this.randomAssign = data['randomAssign'];
    if (this.typeData == 2) {
      this.ownerIds = data['ownerIds'];
      this.urlNew = "leadTransferMultiple";
      this.totalLeads = (this.data && Array.isArray(this.data['leadIds'])) ? this.data['leadIds'].length : 0;
    } else {
      this.ownerId = data['ownerId'];
      this.totalLeads = 1;
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  leadId: any;

  enableTransferReason: any = 0;

  ngOnInit(): void {

    this.getAllCrmData();

    this.initActivity();

    if (this.typeData == undefined) {
      this.typeData = 1
    }

    if (this.typeData == 2) {

      this.firstFormGroup.value.leadIds = this.data['leadIds'];
      this.firstFormGroup.patchValue(this.firstFormGroup.value);
    } else {
      this.firstFormGroup.get("leadId").setValue(this.data['leadId']);
    }

    this.text = "Save";
    this.getUserDropDownList();
    this.usertypeYFilter();

  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['enableTransferReason'] != undefined) {
            this.enableTransferReason = data['enableTransferReason'];
          } else {
            this.enableTransferReason = 0;
          }


        } else {

          this.enableTransferReason = 0;

        }

      } catch (error) {
      }
    }
  }

  initActivity() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      leadId: [''],
      userFromId: [''],
      userFromName: [''],
      userToId: ['',
        conditionalValidator(() => this.randomAssign === 0, Validators.required),
      ],

      userToName: [''],
      transferMessage: [''],
      leadIds: this._formBuilder.array([]),
      randomAssign: this.randomAssign == undefined ? 0 : this.randomAssign,
      ownerMultiCtrl: new UntypedFormControl(),
      ownerId: this._formBuilder.array([]),
    });
  }


  editlead(lead: any) {

    this.firstFormGroup = this._formBuilder.group({
      id: lead.id,
      leadId: lead.leadId,
      userFromId: lead.userFromId,
      userFromName: lead.userFromName,
      userToId: lead.userToId,
      userToName: lead.userToName,
      transferMessage: lead.transferMessage,
      randomAssign: this.randomAssign == undefined ? 0 : this.randomAssign
    })


  }







  close() {
    if (this.isProcessing) {
      return;
    }
    this.dialogRef.close({ event: 'close' });
  }



  //user Group

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

  defaultLeadOwner: FormControl = new FormControl('');

  protected _onDestroy = new Subject<void>();

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;

        if (this.typeData == 1) {
          let index = this.userList.findIndex(x => x.entityId == this.ownerId)
          this.userList.splice(index, 1);
        } else {
          this.ownerIds.forEach(ownerList => {

            let index = this.userList.findIndex(x => x.entityId == ownerList.ownerId)

            if (index > -1) {
              this.userList.splice(index, 1);
            }

          });
        }


        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
        this.cdr.markForCheck();
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }


  listOfOwner: any = [];
  selectOwner(event, values) {
    if (event.isUserInput != false) {
      if (event.source._selected) {
        this.listOfOwner.push(event.source.value);
        this.firstFormGroup.get("ownerMultiCtrl").patchValue(this.listOfOwner);
        // this.firstFormGroup.value.profile.push(values);
      } else {
        let index = this.listOfOwner.findIndex(x => x == event.source.value)
        this.listOfOwner.splice(index, 1);
        this.firstFormGroup.get("ownerMultiCtrl").patchValue(this.listOfOwner);
        // this.firstFormGroup.value.profile.splice(index, 1);
      }
    }
  }

  checkTransferReasonEnable(event) {
    if (event.isUserInput != false) {

      if (this.enableTransferReason == 1) {
        this.enableReason = true;
      } else {
        this.enableReason = false;
      }

    }
  }

  get isSubmitDisabled(): boolean {
    if (this.isProcessing) {
      return true;
    }
    if (this.randomAssign == 0 || this.randomAssign == undefined) {
      if (!this.firstFormGroup?.get('userToId')?.value) {
        return true;
      }
    } else {
      if (!this.listOfOwner || this.listOfOwner.length === 0) {
        return true;
      }
    }
    if (this.enableReason && !this.firstFormGroup?.get('transferMessage')?.value?.toString()?.trim()) {
      return true;
    }
    return false;
  }

  async submit() {
    if (this.isProcessing) {
      return;
    }

    if (this.isSubmitDisabled) {
      this.firstFormGroup.markAllAsTouched();
      return;
    }

    if (this.id != 0) {
      this.firstFormGroup.value.operationType = "Change";
    } else {
      this.firstFormGroup.value.operationType = "New";
    }

    this.isProcessing = true;
    this.errorMessage = "";
    this.completedLeads = 0;
    this.progressPercent = 0;

    const CHUNK_SIZE = 50;
    const allLeadIds: any[] = (this.data && Array.isArray(this.data['leadIds'])) ? this.data['leadIds'] : [];

    if (this.typeData == 2 && allLeadIds.length > CHUNK_SIZE && this.randomAssign == 0) {
      // Chunked batch transfer for large volume (e.g. 200 leads) for optimal performance and live progress tracking
      this.text = "Transferring...";
      let totalSuccess = 0;
      let totalFailed = 0;

      const chunks: any[][] = [];
      for (let i = 0; i < allLeadIds.length; i += CHUNK_SIZE) {
        chunks.push(allLeadIds.slice(i, i + CHUNK_SIZE));
      }

      this.progressText = `Transferring 0 of ${this.totalLeads} leads (0%)...`;

      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i];
        const payload = {
          ...this.firstFormGroup.value,
          leadIds: chunk,
          ownerId: this.listOfOwner
        };

        try {
          const response: any = await this.transferLeadService[this.urlNew](payload).toPromise();
          const failedList = response?.Failed || response?.failed || [];
          const successList = response?.Success || response?.Sucess || response?.success || [];
          const failedCount = Array.isArray(failedList) ? failedList.length : 0;
          const successCount = Array.isArray(successList) ? successList.length : (chunk.length - failedCount);

          totalSuccess += successCount;
          totalFailed += failedCount;
        } catch (err: any) {
          totalFailed += chunk.length;
        }

        this.completedLeads += chunk.length;
        this.progressPercent = Math.min(100, Math.round((this.completedLeads / this.totalLeads) * 100));
        this.progressText = `Transferred ${this.completedLeads} of ${this.totalLeads} leads (${this.progressPercent}%)...`;
      }

      this.isProcessing = false;

      if (totalFailed === 0) {
        const msg = `Owner Changed Successfully: All ${this.totalLeads} leads transferred.`;
        this.snackBar.open(msg, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 4000 });
        this.dialogRef.close({ event: 'add' });
      } else if (totalSuccess > 0) {
        const msg = `Owner Changed: ${totalSuccess} leads transferred successfully, ${totalFailed} failed.`;
        this.snackBar.open(msg, '×', { panelClass: 'warning', verticalPosition: 'bottom', duration: 5000 });
        this.dialogRef.close({ event: 'add' });
      } else {
        this.text = "Save";
        this.errorMessage = "Failed to transfer leads. Please check your network connection and try again.";
        this.snackBar.open(this.errorMessage, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 6000 });
      }
    } else {
      // Single transfer or smaller batch
      if (this.typeData == 2) {
        this.firstFormGroup.value.leadIds = this.data['leadIds'];
        this.firstFormGroup.value.ownerId = this.listOfOwner;
      }

      this.text = "Processing";
      this.progressText = this.totalLeads > 1
        ? `Transferring ${this.totalLeads} leads to the selected owner...`
        : `Transferring lead to the selected owner...`;

      this.transferLeadService[this.urlNew](this.firstFormGroup.value).subscribe(
        (response: any) => {
          this.isProcessing = false;

          if (this.typeData == undefined) {
            this.typeData = 1;
          }

          if (this.typeData == 2) {
            const failedList = response?.Failed || response?.failed || [];
            const successList = response?.Success || response?.Sucess || response?.success || [];
            const failedCount = Array.isArray(failedList) ? failedList.length : 0;
            const successCount = Array.isArray(successList) ? successList.length : Math.max(0, this.totalLeads - failedCount);

            if (failedCount === 0) {
              const msg = this.totalLeads > 1
                ? `Owner Changed Successfully: All ${this.totalLeads} leads transferred.`
                : "Owner Changed Successfully";
              this.snackBar.open(msg, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 4000 });
              this.dialogRef.close({ event: 'add' });
            } else {
              const msg = `Owner Changed: ${successCount} leads transferred successfully, ${failedCount} failed.`;
              this.snackBar.open(msg, '×', { panelClass: 'warning', verticalPosition: 'bottom', duration: 5000 });
              this.dialogRef.close({ event: 'add' });
            }
          } else if (response && response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.snackBar.open(response['status_message'] || "Owner Changed Successfully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 4000 });
            this.dialogRef.close({ event: 'add' });
          } else {
            this.text = "Save";
            const errorMsg = response?.['status_message'] || 'Failed to transfer lead.';
            this.errorMessage = errorMsg;
            this.snackBar.open(errorMsg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
          }
        },
        (err: any) => {
          this.isProcessing = false;
          this.text = "Save";

          let msg = 'Failed to transfer lead. Please try again.';
          if (err && (err.status === 504 || err.status === 408)) {
            msg = `Server timeout: Transferring ${this.totalLeads} leads is taking longer than expected. The transfer may still be processing on the server. Please check the notification center or refresh the leads list in a few moments.`;
          } else if (err && err.status === 0) {
            msg = 'Network connection interrupted. The transfer may still be processing on the server.';
          } else if (err?.error?.message || err?.error?.status_message) {
            msg = err.error.message || err.error.status_message;
          }

          this.errorMessage = msg;
          this.snackBar.open(msg, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 6000 });
        }
      );
    }
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}

